import { createAsyncThunk } from '@reduxjs/toolkit';
import { TOOL_TABS } from '../../constants/toolUIFlags';
import { filesFromMessages } from '../../helper/mediaHelper';
import { getIsAgent } from '../currentUser/currentUserSelectors';
import { getMessages } from '../messages/messagesSelectors';
import { setToolbarTab } from '../uiState/uiStateSlice';

export const newTicketFromMessages = createAsyncThunk(
  'tickets/newTicketFromMessages',
  ({ messageIds }: { channelId?: string; messageIds: string[] }, { getState, dispatch, rejectWithValue }) => {
    if (!getIsAgent(getState() as Parameters<typeof getIsAgent>[0])) {
      return rejectWithValue({ reason: 'agent_required' });
    }

    const messages = getMessages(getState());
    const selectedMessages = messageIds.map((id) => messages[id]);

    const files = filesFromMessages(selectedMessages);

    dispatch(setToolbarTab({ tab: TOOL_TABS.TICKETS }));

    return { messages: selectedMessages, files };
  },
);
